import { useState } from "react";
import { Grid, Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { postFile } from "utils/WebService";
import { errorAlert, successAlert } from "utils/Functions";
import { useMaterialUIController } from "context";

export default function BatimentoGetnet() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [loading, setLoading] = useState(false);

    const handleExportar = () => {
        setLoading(true);
        
        const currentDateStr = new Date().toISOString().slice(0, 10);
        const fileName = `Batimento_Getnet_${currentDateStr}.xlsx`;

        const filtros = {}; // A query do backend já traz as regras hardcoded conforme a regra de negócio

        postFile("/reports/export", {
            fonteDados: "batimentoGetNet",
            filtros: filtros,
            dateFormat: "dd/mm/yyyy",
            valueFormat: "R$ #,##0.00"
        }, fileName)
            .then(() => {
                successAlert("Batimento gerado com sucesso!");
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                errorAlert("Erro ao exportar Arquivo de Batimento.");
                setLoading(false);
            });
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Card
                    variant="outlined"
                    sx={{
                        p: 2,
                        mb: 2,
                        background: darkMode ? "#4B4F5C" : "#fff",
                        borderColor: darkMode ? "#333" : "#ddd",
                    }}
                >
                    <MDBox p={1} pb={2} display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" color={darkMode ? "white" : "dark"}>
                            Exportar Arquivo de Batimento - Getnet
                        </MDTypography>
                    </MDBox>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ px: 1, pb: 0.3, display: "block" }}>
                                Cliente Associado
                            </MDTypography>
                            <MDInput 
                                fullWidth 
                                value="Getnet" 
                                disabled 
                                sx={{
                                    "& .MuiInputBase-root": {
                                        backgroundColor: darkMode ? "#4B4F5C" : "#f5f5f5"
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1.5} pt={1.5}>
                            <MDButton 
                                variant="contained" 
                                color="info" 
                                size="small"
                                onClick={handleExportar}
                                disabled={loading}
                            >
                                {loading ? "Gerando..." : <><Icon sx={{ mr: 1 }}>download</Icon> Gerar e Baixar (Excel)</>}
                            </MDButton>
                        </Grid>
                    </Grid>

                    <MDBox mt={3} p={2} sx={{ backgroundColor: darkMode ? "#4B4F5C" : "#f8f9fa", borderRadius: 2 }}>
                        <MDTypography variant="subtitle2" color="text" fontWeight="medium" mb={1}>
                            Regras de Extração (Automáticas):
                        </MDTypography>
                        <MDTypography variant="caption" color="text" display="block">
                            • Apenas casos com Negociação em Andamento.
                        </MDTypography>
                        <MDTypography variant="caption" color="text" display="block">
                            • Apenas casos com Acordo Cancelado e não pagos após 10 dias de atraso.
                        </MDTypography>
                        <MDTypography variant="caption" color="text" display="block">
                            • Apenas casos em Tratativas onde a data de devolução passou de 40 dias.
                        </MDTypography>
                    </MDBox>
                </Card>
            </Grid>
        </Grid>
    );
}
